var ProductStatus;
(function(ProductStatus) {
    ProductStatus["AVAILABLE"] = 'Available';
    ProductStatus["NOT_FOR_SALE"] = 'Not-for-sale';
    ProductStatus["OUT_OF_STOCK"] = 'Out-of-stock';
    ProductStatus["AVAILABLE_ONE_LEFT"] = 'Available-oneleft';
    ProductStatus["AVAILABLE_TWO_LEFT"] = 'Available-twoleft';
    ProductStatus["AVAILABLE_FEW_LEFT"] = 'Available-fewleft';
})(ProductStatus || (ProductStatus = {}));
var ProductCategory;
(function(ProductCategory) {
    ProductCategory["OPTICS"] = "OPTICS";
    ProductCategory["SUN"] = "SUN";
    ProductCategory['CONTACT_LENSES'] = 'CONTACT LENSES';
    ProductCategory['EYEWEAR'] = 'EYEWEAR';
    ProductCategory["ACCESSORIES"] = "ACCESSORIES";
})(ProductCategory || (ProductCategory = {}));

export { ProductCategory, ProductStatus };
//# sourceMappingURL=products.js.map
